__turbopack_context__.v({
  "arrow": "paginator-module-scss-module__bvmCoW__arrow",
  "arrowIsDisabled": "paginator-module-scss-module__bvmCoW__arrowIsDisabled",
  "arrowNext": "paginator-module-scss-module__bvmCoW__arrowNext",
  "arrowPrevious": "paginator-module-scss-module__bvmCoW__arrowPrevious",
  "clearIndicator": "paginator-module-scss-module__bvmCoW__clearIndicator",
  "controlContent": "paginator-module-scss-module__bvmCoW__controlContent",
  "countWithError": "paginator-module-scss-module__bvmCoW__countWithError",
  "countryFlagMultiValue": "paginator-module-scss-module__bvmCoW__countryFlagMultiValue",
  "countryFlagOption": "paginator-module-scss-module__bvmCoW__countryFlagOption",
  "countryFlagSingleValue": "paginator-module-scss-module__bvmCoW__countryFlagSingleValue",
  "dropdownIndicator": "paginator-module-scss-module__bvmCoW__dropdownIndicator",
  "hiddenValuesCount": "paginator-module-scss-module__bvmCoW__hiddenValuesCount",
  "itemsPerPage": "paginator-module-scss-module__bvmCoW__itemsPerPage",
  "multiValue": "paginator-module-scss-module__bvmCoW__multiValue",
  "multiValueContainer": "paginator-module-scss-module__bvmCoW__multiValueContainer",
  "multiValueContainerNoWrap": "paginator-module-scss-module__bvmCoW__multiValueContainerNoWrap",
  "multiValueIsNotValid": "paginator-module-scss-module__bvmCoW__multiValueIsNotValid",
  "multiValueIsVisible": "paginator-module-scss-module__bvmCoW__multiValueIsVisible",
  "multiValueRemoveIcon": "paginator-module-scss-module__bvmCoW__multiValueRemoveIcon",
  "multiValueRemoveIconWrapper": "paginator-module-scss-module__bvmCoW__multiValueRemoveIconWrapper",
  "multiValueWithValidationTooltip": "paginator-module-scss-module__bvmCoW__multiValueWithValidationTooltip",
  "pagination": "paginator-module-scss-module__bvmCoW__pagination",
  "paginationInput": "paginator-module-scss-module__bvmCoW__paginationInput",
  "paginationInputWrp": "paginator-module-scss-module__bvmCoW__paginationInputWrp",
  "paginationWrp": "paginator-module-scss-module__bvmCoW__paginationWrp",
  "paginatorControls": "paginator-module-scss-module__bvmCoW__paginatorControls",
  "paginatorInfo": "paginator-module-scss-module__bvmCoW__paginatorInfo",
  "paginatorWrapper": "paginator-module-scss-module__bvmCoW__paginatorWrapper",
  "placeholder": "paginator-module-scss-module__bvmCoW__placeholder",
  "selectEncapsulation": "paginator-module-scss-module__bvmCoW__selectEncapsulation",
  "selectPortalEncapsulation": "paginator-module-scss-module__bvmCoW__selectPortalEncapsulation",
  "selectSpinner": "paginator-module-scss-module__bvmCoW__selectSpinner",
  "treeSelectMenu": "paginator-module-scss-module__bvmCoW__treeSelectMenu",
});
